import {
  TablePage,
  AddPage,
  EditPage,
  ViewPage,
} from 'src/views/abi/tradepartner'
import pathMap from 'src/paths/pathMap'
import React from 'react'

class AbiTradePartnerRoute {
  getConfigurations() {
    return [
      {
        exact: true,
        path: pathMap.ABI_TRADE_PARTNER_LIST_VIEW,
        component: TablePage
      },
      {
        exact: true,
        path: pathMap.ABI_TRADE_PARTNER_ADD_VIEW,
        component: AddPage
      },
      {
        exact: true,
        path: pathMap.ABI_TRADE_PARTNER_EDIT_VIEW,
        component: EditPage
      },
      {
        exact: true,
        path: pathMap.ABI_TRADE_PARTNER_DETAILS_VIEW,
        component: TablePage
      },
      {
        exact: true,
        path: pathMap.ABI_TRADE_PARTNER_VIEW,
        component: ViewPage
      },
    ]
  }
}

export default AbiTradePartnerRoute
